export const BLOG_TOPICS = [
  { value: 'DIGITAL Hospital', slug: 'DIGITAL-Hospital', fa: 'بیمارستان دیجیتال' },
  { value: 'Technology', slug: 'Technology', fa: 'فناوری' },
  { value: 'Art', slug: 'Art', fa: 'هنر' },
  { value: 'Furniture', slug: 'Furniture', fa: 'مبلمان' },
];
export function findBlogTopic(value) {
  const normalized = (value || '').replace(/[- ]/g, '').toLowerCase();
  return BLOG_TOPICS.find(t => t.value.replace(/ /g, '').toLowerCase() === normalized);
}
export function blogPath(blog) {
  const topic = findBlogTopic(blog.topic);
  return topic ? `/blog/${topic.slug}/${encodeURIComponent(blog.slug)}` : `/blog/${encodeURIComponent(blog.slug)}`;
}
export const ARTICLE_SLUG_ALIASES = {
  'architecture-before-the-first-line': 'art-in-everyday-architecture',
  'renovation-before-demolition': 'furniture-that-makes-a-room-work',
  'drywall-details-that-make-the-difference': 'digital-hospital-starts-with-the-space',
};
export function blogSearchFilter(search) {
  const pattern = `%${search.replace(/[\\%_]/g, '\\$&').replace(/"/g, '\\"')}%`;
  return ['title_fa','title_en','description_fa','description_en','author'].map(field => `${field}.ilike."${pattern}"`).join(',');
}
